/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetInspectionResponse
 */
export interface AssetInspectionResponse {
    /**
     * 
     * @type {number}
     * @memberof AssetInspectionResponse
     */
    inspectionId?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInspectionResponse
     */
    assetId?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInspectionResponse
     */
    mineLocationId?: number;
}

/**
 * Check if a given object implements the AssetInspectionResponse interface.
 */
export function instanceOfAssetInspectionResponse(value: object): value is AssetInspectionResponse {
    return true;
}

export function AssetInspectionResponseFromJSON(json: any): AssetInspectionResponse {
    return AssetInspectionResponseFromJSONTyped(json, false);
}

export function AssetInspectionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetInspectionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'inspectionId': json['inspectionId'] == null ? undefined : json['inspectionId'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'mineLocationId': json['mineLocationId'] == null ? undefined : json['mineLocationId'],
    };
}

export function AssetInspectionResponseToJSON(json: any): AssetInspectionResponse {
    return AssetInspectionResponseToJSONTyped(json, false);
}

export function AssetInspectionResponseToJSONTyped(value?: AssetInspectionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inspectionId': value['inspectionId'],
        'assetId': value['assetId'],
        'mineLocationId': value['mineLocationId'],
    };
}

